import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';
import { CollapsibleBoxStyle } from '~/components/selection-card-new/styles/selection-card-styles';

export const CollapsibleBox = ({
	boxExpanded,
	children,
	className,
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
	boxExpanded: boolean;
	children: ReactNode;
}) => {
	return (
		<CollapsibleBoxStyle className={`${!boxExpanded ? 'is-hidden' : ''}`}>
			<div className={`inner-container ${className ?? ''} ${!boxExpanded ? 'is-hidden' : ''}`}>{children}</div>
		</CollapsibleBoxStyle>
	);
};
